export { default } from './RulesList.component';
export * from './RulesList.component';
